<!--
 * @Author: 范向玲
 * @Date: 2022-11-07 10:16:08
 * @LastEditTime: 2024-12-27 15:42:17
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @Description: 走势库数据管理
 * @FilePath: \web\src\components\ProjectPerformance\DataManager\index.vue
-->
<template>
  <section class="trend-data-management">
    <section class="trend-search-container">
      <SearchModule @submit="searchHandle" />
      <div class="crud-wrapper">
        <div class="crud-item" @click="sort()">排序</div>
        <!-- <div class="crud-item" @click="add()">新增</div> -->
        <div class="crud-item" @click="importData()">导入</div>
        <div class="crud-item" @click="selectDel()"
          :class="selectedKeys.length > 0 ? 'crud-item-abled' : 'crud-item-disabled'">
          删除
        </div>

        <div class="crud-item" @click="selectDownload()"
          :class="selectedKeys.length > 0 ? 'crud-item-abled' : 'crud-item-disabled'">
          导出
        </div>
      </div>
    </section>
    <a-table rowKey="id" class="trend-datamanager-table" :dataSource="trendDataManagerPages"
      :loading="trendDataManagerPagesLoading" :columns="columns" @change="changePage" :row-selection="rowSelection"
      :scroll="{ y: '90%' }" :pagination="paginationOption">
      <template #serial="{ index }">{{ index + 1 }}</template>
      <template #axis="{ record }">{{ record.axis == 0 ? '左' : '右' }}</template>
      <template #action="{ record, index }">
        <section class="action-icons">
          <i v-for="(item, i) in tableOperationList" :key="i" v-bind="item.option" :style="{
            color:
              (item.option.title === '上移' && index <= 0) ||
                (item.option.title === '下移' && index === trendDataManagerPages.length - 1)
                ? 'rgba(255, 200, 120, 0.6)'
                : 'rgb(255, 200, 120)',
          }" @click="item.click(record, index)">
          </i>
        </section>
      </template>
    </a-table>

    <Modal :option="confirmModalConf" @confirm="confirm" @close="close">
      <template v-slot:main>
        <section class="detail-modal-container" v-if="confirmModalConf.type === 'sort'">
          <Sort :headerInfo="detailHeaderConf" :code="recordCode" />
        </section>
        <section class="detail-modal-container" v-if="confirmModalConf.type === 'detail'">
          <RecordDetail :headerInfo="detailHeaderConf" :code="recordCode" />
        </section>
        <section class="detail-modal-container" v-if="confirmModalConf.type === 'edit'">
          <RecordEdit :headerInfo="detailHeaderConf" :code="recordCode" :formState="formState" ref="formRef" />
        </section>
        <section class="down-modal-container" v-if="confirmModalConf.type === 'download'">
          <RecordDownload :option="downloadConf" />
        </section>
        <section class="import-modal-container" v-if="confirmModalConf.type === 'batchImport'">
          <ImportData @fileList="importFileList" />
        </section>
      </template>
    </Modal>
    <!-- / 操作弹出框 -->
  </section>
</template>

<script setup>
import { ref, reactive, computed, toRefs, onBeforeMount, toRaw, } from 'vue';
import { useStore, } from 'vuex';
import { CaretDownOutlined, } from '@ant-design/icons-vue';
import SearchModule from './search.vue';
import { tableConfig, detailTableConfig, downloadInfoConf, } from './tableConfig.js';
import Modal from '@/components/lib/Modal/modal1.vue';
import config from '@/config/config';
import {
  removeTrendDataApi,
  trendDataImport,
  trendDataDownApi,
  getMineralNewListApi,
  trendDataChangeApi,
} from '@/api/projectPerformance/dataManager.js';
import { GET_TREND_DATA_MANAGER_PAGE, } from '@/store/modules/actions/trendDataManager.js';
import RecordDetail from './detail.vue';
import RecordEdit from './edit.vue';
import RecordDownload from './download.vue';
import Sort from './sort.vue';
import ImportData from './importData.vue';
import { downLoadUtil, } from '@/components/utils/utils';

const columns = tableConfig;
const detailColumns = detailTableConfig;

const { state, dispatch: storeDispatch, commit: storeCommit, } = useStore();
// state
const trendDataManagerState = computed(() => state.trendDataManager);
const { mineList, requestParams, trendDataManagerPages, totalCount, sortPages, trendDataManagerPagesLoading, } = toRefs(
  trendDataManagerState.value
);

// 重写commit
const commit = (space, methods, params) => storeCommit(`${space || 'trendDataManager'}/${methods}`, params);
// 重写dispatch
const dispatch = (space, methods, params) => storeDispatch(`${space || 'trendDataManager'}/${methods}`, params);

const selectedKeys = ref([]); // 表格选中id

let formState = ref({
  commodity: '',
  name: '',
  type: '',
  frequency: '',
  unit: '',
  source: '',
  axis: '',
});
const paginationOption = computed(() => ({
  total: totalCount.value,
  pageSize: requestParams.value.size,
  current: requestParams.value.page,
  showSizeChanger: true,
  showQuickJumper: true,
  pageSizeOptions: ['6', '10', '20', '30', '40', '50',],
}));

// 确认弹窗 公用
const confirmModalConf = reactive({
  loading: false,
  visible: false,
  title: '',
  confirm: null,
  remark: '',
  callback: null,
  selectValue: [],
  type: '',
  notFooter: false, // 是否显示底部内容
  width: '5.4rem',
  fileList: [],
});

const recordCode = ref(''); // 表格数据编码

const downloadConf = reactive(downloadInfoConf);
// 详情页矿种信息
const detailHeaderConf = reactive([
  {
    label: '矿种',
    value: '',
  },
  {
    label: '单位',
    value: '',
  },
]);

// 数据详情
const detailRecord = (record) => {
  recordCode.value = record.code;
  detailHeaderConf[0].value = record.commodity;
  detailHeaderConf[1].value = record.unit;
  commit(null, 'setDetailRequestParams', { code: [record.code,], });
  confirmModalConf.title = '历史价格';
  confirmModalConf.type = 'detail';
  confirmModalConf.notFooter = true;
  confirmModalConf.width = '10rem';
  confirmModalConf.visible = true;
};
/**
 * @description 查询
 */
const searchHandle = () => {
  dispatch(null, GET_TREND_DATA_MANAGER_PAGE);
};
/**
 *
 * @param {*} record 预编辑数据信息
 */
// 编辑确认
const formRef = ref();
const submitEdit = () => {
  formRef.value.formRef
    .validate()
    .then(() => {
      trendDataChangeApi(formState.value).then((res) => {
        if (res.code === 200 && res.data.code === 200) {
          confirmModalConf.visible = false;
          confirmModalConf.type = '';
          searchHandle();
        }
      });
    })
    .catch((error) => {
      console.log('error', error);
    });
};
const editRecord = (record) => {
  formState.value = JSON.parse(JSON.stringify(record));
  confirmModalConf.title = '编辑';
  confirmModalConf.callback = () => submitEdit();
  confirmModalConf.visible = true;
  confirmModalConf.type = 'edit';
  confirmModalConf.width = '10rem';
};

// 数据上移
const upRecord = (record, index) => {
  if (index <= 0) {
    console.log('已经是第一条了');
  } else {
    let updata = trendDataManagerPages.value[index - 1];

    trendDataManagerPages.value.splice(index - 1, 1);
    trendDataManagerPages.value.splice(index, 0, updata);
  }
};
// 数据下移
const downRecord = (record, index) => {
  if (index === trendDataManagerPages.value.length - 1) {
    console.log('已经是最后一条了');
  } else {
    let downdata = trendDataManagerPages.value[index + 1];

    trendDataManagerPages.value.splice(index + 1, 1);
    trendDataManagerPages.value.splice(index, 0, downdata);
  }
};
// -------------------- 删除
// 开始删除
const delInfo = (ids) => {
  removeTrendDataApi(ids).then((res) => {
    confirmModalConf.visible = false;
    searchHandle();
  });
};
// 单行数据删除之前
const beforeDel = (ids) => {
  confirmModalConf.title = '确认删除项目？';
  confirmModalConf.callback = () => delInfo(ids);
  confirmModalConf.visible = true;
};
// 单行删除
const delRecord = (record) => {
  const { id, } = record;

  beforeDel([id,]);
};
/**
 * @description 勾选删除
 */
const selectDel = () => {
  const ids = selectedKeys.value;

  beforeDel(ids);
};

// -------------------- 导入
const importFileList = (data) => {
  confirmModalConf.fileList = data;
};
const submitImport = () => {
  let formData = new FormData();

  formData.set('file', confirmModalConf.fileList[0].originFileObj);
  trendDataImport(formData).then((res) => {
    if (res.code === 200 && res.data.code === 200) {
      confirmModalConf.visible = false;
      confirmModalConf.fileList = [];
      confirmModalConf.type = '';
      searchHandle();
    }
  });
};
const importData = () => {
  confirmModalConf.title = '数据导入';
  confirmModalConf.callback = () => submitImport();
  confirmModalConf.visible = true;
  confirmModalConf.type = 'batchImport';
};

// -------------------- 导出
// 开始导出
const downloadInfo = (ids, codes) => {
  const params = { code: codes, ids: ids.join(','), order: downloadConf[0][0].selectValue, }

  trendDataDownApi(params, true).then((res) => {

    downLoadUtil(res).then(() => { });
    confirmModalConf.visible = false;
    // 下载接口调用成功
    downloadConf.forEach((arr) => {
      arr.forEach((item) => {
        item.selectValue = item.valueType === 'arr' ? [] : '';
      });
    });

  });
};
// 单行数据下载之前
const beforeDownload = (ids, codes) => {
  confirmModalConf.title = '导出数据';
  confirmModalConf.callback = () => downloadInfo(ids, codes);
  confirmModalConf.visible = true;
  confirmModalConf.type = 'download';
  confirmModalConf.width = '7rem';
};
// 单行数据下载
const downloadRecord = (record, index) => {
  const { id, code, } = record;

  beforeDownload([id,], [code,]);
};
/**
 * @description 勾选导出
 */
const selectDownload = () => {
  const ids = selectedKeys.value;

  let codes = [];

  trendDataManagerPages.value.forEach((item) => {
    selectedKeys.value.forEach((i) => {
      if (i === item.id) {
        codes.push(item.code);
      }
    });
  });

  beforeDownload(ids, codes);
};

const tableOperationList = ref([]);

// 新增 删除的权限控制
const operationConf = [1, 2,];

// 操作的权限
const tableOperationListConf = [
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-gengduo',
      title: '详情',
    },
    click: detailRecord,
    operation: [1, 2, 3,],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-bianjishuru',
      title: '编辑',
    },
    click: editRecord,
    operation: [1, 2, 3,],
  },
  // {
  //   option: {
  //     style: 'color: rgb(255, 200, 120)',
  //     class: 'iconfont icon-jiantou_xiangshang',
  //     title: '上移',
  //   },
  //   click: upRecord,
  //   operation: [1, 2],
  // },
  // {
  //   option: {
  //     style: 'color: rgb(255, 200, 120)',
  //     class: 'iconfont icon-jiantou_xiangxia',
  //     title: '下移',
  //   },
  //   click: downRecord,
  //   operation: [1, 2],
  // },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-shanchu',
      title: '删除',
    },
    click: delRecord,
    operation: [1, 2,],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-xiazaidaoru',
      title: '下载',
    },
    click: downloadRecord,
    operation: [1, 2,],
  },
];

/**
 * @description 表格选中事件
 */
const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    selectedKeys.value = selectedRowKeys;
  },
};
/**
 * @description 排序
 */
const submitSort = () => {
  sortPages.value.forEach((item, index) => {
    item.orderNum = index + 1;
  });
  getMineralNewListApi(sortPages.value).then((res) => {
    if (res.code === 200 && res.data.code === 200) {
      confirmModalConf.visible = false;
      confirmModalConf.type = '';
      searchHandle();
    }
  });
};
const sort = () => {
  confirmModalConf.title = '矿种排序';
  confirmModalConf.callback = () => submitSort();
  confirmModalConf.visible = true;
  confirmModalConf.type = 'sort';
  confirmModalConf.width = '10rem';
};


/**
 * @description 新增
 */
const add = () => { };

/**
 * @description 页码change事件
 */
const changePage = (page) => {
  commit(null, 'setRequestParams', { page: page.current, size: page.pageSize, });
  searchHandle();
};
/**
 * @description 关闭通用弹窗
 */
const close = () => {
  confirmModalConf.visible = false;
  confirmModalConf.notFooter = false;
  confirmModalConf.title = '';
  confirmModalConf.type = '';
  confirmModalConf.width = '5.4rem';
};

/**
 * @description 确认通用弹窗
 */
const confirm = () => {
  confirmModalConf.callback();
};

onBeforeMount(() => {
  tableOperationList.value = tableOperationListConf;
  searchHandle();
});
</script>

<style lang="scss">
.trend-data-management {
  color: #fff;
  height: 100%;

  /* 检索条件 */
  .trend-search-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 0.1rem;
    height: 0.5rem;
    margin-bottom: 0.1rem;

    .crud-wrapper {
      display: flex;
      height: 0.51rem;
      padding: 0.13rem 0.1rem;

      .crud-item {
        margin-right: 0.04rem;
        width: 0.5rem;
        color: #fff;
        // background-color: #efb227;
        background-image: url(~@/static/images/dataManagement/curd_btn.png);
        background-size: 100% 100%;
        text-align: center;
      }

      .crud-item:hover {
        cursor: pointer;
      }

      .crud-item-disabled {
        pointer-events: none;
        color: rgba(255, 255, 255, 0.6);
        // background-color: rgba(239, 178, 39, 0.6);
        opacity: 0.8;
      }

      .crud-item-disabled:hover {
        cursor: no-drop;
      }
    }
  }

  /* 表格样式 */
  .trend-datamanager-table {
    height: calc(100% - 0.6rem);

    .ant-spin-container {
      display: flex;
      flex-direction: column;
      align-items: end;
    }

    .ant-spin-nested-loading,
    .ant-spin-container,
    .ant-table-content {
      height: 100%;
    }

    .ant-table {
      height: calc(100% - .50rem);
      background: none;
      padding-left: 0.1rem;

      .ant-table-scroll {
        height: 100%;
        overflow: visible;
        overflow-x: visible;

        .ant-table-header {
          overflow: visible !important;
          margin-bottom: 0 !important;
        }
      }

      .ant-table-header {
        background: none;
      }

      .ant-table-body {
        overflow-x: hidden !important;
        overflow-y: auto !important;
        background: none;
      }

      /* 矿种 */
      .primary-commodity-img {
        width: 0.8rem;
        height: 0.6rem;
      }

      /* 图标 */
      .action-icons {
        i {
          font-size: 0.22rem;
          margin-right: 0.04rem;
          cursor: pointer;
        }
      }

      .ant-table-thead {
        border: .01rem solid #4d3f1c;
        border-radius: .10rem .10rem 0rem 0rem;
        background: none;
      }

      .ant-table-thead>tr>th {
        color: #ffc44d;
        background: rgba(179, 150, 92, 0.2);
        border: none;
      }

      .ant-table-tbody>tr>td {
        background-color: transparent;
        color: #fff;
        border-bottom: .01rem solid rgba(179, 150, 92, 1);
        vertical-align: middle;
      }

      .ant-table-placeholder {
        height: 100%;
        background-color: rgba(77, 63, 28, 1);
        border-top: rgba(179, 150, 92, 1);
        border-bottom: rgba(179, 150, 92, 1);
      }

      .ant-empty-normal {
        color: rgba(179, 150, 92, 1);
      }

      // 暂无数据填充样式
      // .ant-empty-img-simple-path {
      //   fill: rgba(77, 63, 28, 1);
      // }
      // .ant-empty-img-simple-ellipse {
      //   fill: rgba(77, 63, 28, 1);
      // }
      .ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-thead>tr:hover.ant-table-row-selected>td,
      .ant-table-tbody>tr:hover.ant-table-row-selected>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-tbody>tr.ant-table-row-selected td {
        background-color: rgba(77, 63, 28, 1);
        color: #fff;
      }
    }


  }
}
</style>
